module.exports = require("@pb/kit-component-floating");